import { Link } from "react-router-dom";
import {useState, useEffect } from "react";
import $ from 'jquery';
import apiClient from "../../http-common";
import { useStateWithCallbackLazy } from 'use-state-with-callback';
import { HTTPURL } from "../../constants/matcher";
// import Loader from "react-js-loader";
import useConfirm from "../../customHooks/useConfirm";
import {useFetchApi} from "../../customHooks/useFetch";
import { toast } from 'react-toastify';
import DataLoader from "../../Utils/DataLoader";

const Servants = () => {
    const [reqData, setreqData] = useState({}); // <-- add state
    const { resData } = useFetchApi(reqData); // <-- pass location value to hook
    const {confirm} = useConfirm();
    const [message, setMessage] = useState('');
    const [users, setUsers] = useStateWithCallbackLazy([]);
    const [showResults, setShowResults] = useStateWithCallbackLazy(false)
    
    const lastSegment = window.location.pathname.split("/").pop();

    const showConfirm = async (id) => {
        console.log(id)
        const isConfirmed = await confirm('Do you confirm your choice?');

        if (isConfirmed) {
            console.log('Confirmed!')
            deleteUser(id);
        } else {
            console.log('Declined.')
        }
    }

    useEffect( () => {
        console.log("servants--mentors");

        getAllData();

        if(Object.keys(resData).length !== 0){
            if(resData.status===true){
                toast.success(resData.message)
            }else{
               toast.error(resData.message)
            }
        }

    // }, [resData]);
    }, [resData, lastSegment]);

    const deleteUser = (requestData) => {
        requestData = {
            // 'type' : 'post',
            // 'head' : 'head',
            'link' : 'admin/delete-user/'+requestData,
            // 'data' : requestData,
            'token' : 'required',
        };
        setreqData(requestData);
    }

    async function getAllData() {
        try {
            const type = lastSegment=='civil-servants' ? 0 : 1;
            const res = await apiClient.get("/admin/userList/"+type);

            setUsers(res.data.data, () => {
                setShowResults(true, () => {
                    $('#datatablesSimple').DataTable();
                });
            });

        } catch (err) {
            console.log(err)
        }
    }

    const handleDeleteAll = () => 
    {
        //
    }
          
    return (
        <main>
            <div className="container-fluid px-4">
                <h1 className="mt-4">{lastSegment=='civil-servants' ? 'Civil Servants' : 'Mentors'}</h1>
                <ol className="breadcrumb mb-4">
                    <Link to="/secure/dashboard" className="breadcrumb-item">Dashboard</Link>
                    <Link className="breadcrumb-item active">{lastSegment=='civil-servants' ? 'Civil Servants' : 'Mentors'}</Link>
                </ol>

                <div className="card mb-4">
                    <div className="card-header">
                        <i className="fas fa-table me-1"></i>
                        Civil Servants List
                    </div>
                    <div className="card-body">
                        { showResults ? 
                            <table id="datatablesSimple">
                                <thead>
                                    <tr>
                                        <th>Photo</th>
                                        <th>First Name</th>
                                        <th>Last Name</th>
                                        <th>E-mail</th>
                                        <th>Created At</th>
                                        <th>Action</th>
                                    </tr>
                                </thead>
                                
                                {users.length > 0 && (
                                    <tbody>
                                    {users.map(user => (
                                        <tr key={user.id}>
                                            <td>
                                                <img src={HTTPURL+'images/'+(user.photo?user.photo:'default.png')} width='50' height='50' alt="No Image"/>
                                            </td>
                                            <td>{user.firstName}</td>
                                            <td>{user.lastName}</td>
                                            <td>{user.email}</td>
                                            <td>{user.created_at}</td>
                                            <td>
                                                <ul className="list-inline m-0">
                                                    <li className="list-inline-item">
                                                            <Link to={"./view/"+ user.id} title="View" className="btn dropdown-item sap-btn-light"><i className="fa-solid fa-eye"></i></Link>
                                                    </li>
                                                    {/* <li className="list-inline-item">
                                                        <button className="btn btn-success btn-sm rounded-0" type="button" data-toggle="tooltip" data-placement="top" title="Edit" onClick={handleDeleteAll}><i className="fa fa-edit"></i></button>
                                                    </li>  */}
                                                    <li className="list-inline-item">
                                                        <button className="btn dropdown-item sap-btn-light" type="button" data-toggle="tooltip" data-placement="top" title="Delete" onClick={() => showConfirm(user.id)}><i className="fa fa-trash"></i></button>
                                                    </li> 
                                                    
                                                    {
                                                        lastSegment=='civil-servants' ? ''
                                                        : 
                                                        <li className="list-inline-item">
                                                            <Link to={"./match-making/"+user.id} title="Match-Making" className="btn dropdown-item sap-btn-light">Match</Link>
                                                        </li>
                                                    }
                                                    
                                                </ul>
                                            </td>
                                        </tr>
                                    ))}
                                    </tbody>
                                )}
                                
                            </table>
                        : <DataLoader/> }

                    </div>
                </div>
            </div>
        </main>
    )
};

export default Servants;